import { Injectable } from '@angular/core';
import { BaseService } from '../abstracts/base.service';
import { AnnouncementModel } from '../models/announcement.model';
import { ResultModel } from '../models/result.model';

@Injectable({
  providedIn: 'root'
})
export class AnnouncementService extends BaseService {

  create(announcement: AnnouncementModel) {
    return this.httpClient.post<ResultModel>(this.getApiUrl("announcement"), announcement);
  }

  update(announcement: AnnouncementModel) {
    return this.httpClient.put(this.getApiUrl('announcement'), announcement);
  }

  delete(announcementID: string) {
    return this.httpClient.delete<ResultModel<AnnouncementModel>>(this.getApiUrl(`announcement/${announcementID}`));
  }

  get(announcementID: string) {
    return this.httpClient.get<ResultModel<AnnouncementModel>>(this.getApiUrl(`announcement/${announcementID}`));
  }

  /**
   * yönetim ekranında datatable veri listeleme için kullanılır. Tüm duyurular görüntülenir.
   * @param formData datatable params
   */
  listAllForDataTable(formData?: FormData) {
    return this.httpClient.post<ResultModel<AnnouncementModel[]>>(this.getApiUrl("announcement/list"), formData);
  }

  /**
   * yönetim tarafından oluşturulmuş ve yayında olan duyurular tenant kullanıcıları için getirilir. Sadece yayında ve süresi bitmemiş duyurular getirilir.
   */
  listAllPublished() {
    return this.httpClient.get<ResultModel<AnnouncementModel[]>>(this.getApiUrl("announcement/list-all"));
  }

  createMaster(announcement: AnnouncementModel) {
    return this.httpClient.post<ResultModel>(this.getApiUrl("mannouncement"), announcement);
  }

  updateMaster(announcement: AnnouncementModel) {
    return this.httpClient.put(this.getApiUrl('mannouncement'), announcement);
  }

  deleteMaster(announcementID: string) {
    return this.httpClient.delete<ResultModel<AnnouncementModel>>(this.getApiUrl(`mannouncement/${announcementID}`));
  }

  getMaster(announcementID: string) {
    return this.httpClient.get<ResultModel<AnnouncementModel>>(this.getApiUrl(`mannouncement/${announcementID}`));
  }

  /**
   * perasis tenant yönetimi ekranında duyuruları datatable ile listelemek için kullanılır. Tüm perasis duyuruları görüntülenir. (Tenantların kendi içlerinde oluşturdukları duyurular görüntülenmez)
   * @param formData datatable params
   */
  listAllMasterForDataTable(formData?: FormData) {
    return this.httpClient.post<ResultModel<AnnouncementModel[]>>(this.getApiUrl("mannouncement/list"), formData);
  }

  /**
   * perasis tarafından oluşturulmuş ve yayında olan duyurular tenantlar için getirilir. Sadece yayında ve süresi bitmemiş duyurular getirilir.
   */
  listAllMasterPublished() {
    return this.httpClient.get<ResultModel<AnnouncementModel[]>>(this.getApiUrl("mannouncement/list-all"));
  }


  listAllAnnouncement() {
    return this.httpClient.get<ResultModel<AnnouncementModel[]>>(this.getApiUrl("allannouncement/list-all"));
  }

}
